import { useEffect } from 'react';
import to from 'await-to-js';
import { apiClient, useEntityData } from 'c-data';
import { useAPIClientRequest } from 'c-hooks';
import type { Buyer } from 'c-sdk';

function useLoadBuyerLatestCost(buyerId?: number) {
    const { start } = useAPIClientRequest(apiClient.Entities.Buyer.get);
    const { upsertEntity } = useEntityData<Buyer>('Buyer');

    useEffect(() => {
        if (buyerId == null || !Number.isFinite(buyerId) || buyerId <= 0) return;

        (async () => {
            const [, response] = await to(start(buyerId, ['latestCost']));
            const buyer = (response as any)?.data?.data as Buyer | undefined;
            if (buyer != null) upsertEntity(buyer);
        })();
    }, [buyerId, start, upsertEntity]);
}

export default useLoadBuyerLatestCost;
